// const defaultApiRoute = "https://rivero_api.test/api";
const defaultApiRoute = "https://api.riverosl.es/api";

export default {
	defaultApiRoute: defaultApiRoute,
};
